import { useNavigate } from "react-router-dom";

import { repeatCashEntryText } from "@/utils/billingPeriod.helpers";
import { Models } from "api/types";
import { RepeatCashEntry } from "molecules/repeat-cash-entry/RepeatCashEntry";
import { useFeatureFlag } from "services/Flags";

export interface RepeatCashTransactionListProps {
  transactions: Models<"RepeatCashTransactionModel">[];
  platformMemberships?: Models<"MembershipModel">[];
}

export const RepeatCashTransactionList = ({
  transactions,
  platformMemberships,
}: RepeatCashTransactionListProps) => {
  const navigate = useNavigate();
  const beautyBankFlag = useFeatureFlag("membershipBeautyBank");
  const isFlexibleMembershipsEnabled = useFeatureFlag(
    "flexible_membership_terms"
  );

  if (!transactions.length) return null;

  const navigateToSource = (
    transaction: Models<"RepeatCashTransactionModel">
  ) => {
    const { rewardId, shopDisplayOrderId, referralRewardId } =
      transaction.source;
    const reason = transaction.reason;
    if (!rewardId && !shopDisplayOrderId && !reason && !referralRewardId)
      return;

    if (rewardId !== null) {
      navigate(`/rewards/${rewardId}`);
    } else if (shopDisplayOrderId !== null) {
      navigate(`/account/orders/${shopDisplayOrderId}`);
    } else if (reason) {
      navigate(`/account/wallet/repeatcash/${transaction.id}`);
    }
  };

  const findMembership = (
    transaction: Models<"RepeatCashTransactionModel">
  ) => {
    if (!platformMemberships) return null;
    return platformMemberships.find(
      (membership) => membership.id === transaction.source.membershipId
    );
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="px-8 text-sub2 uppercase text-secondary">
        Recent Activity
      </div>
      <div className="flex flex-col overflow-clip">
        {transactions?.map((i) => {
          const onClickHandler =
            i.source.rewardId ||
            i.source.shopDisplayOrderId ||
            (beautyBankFlag && i.reason)
              ? () => navigateToSource(i)
              : undefined;

          const relatedMembership = findMembership(i);
          const intervalText = repeatCashEntryText(relatedMembership);

          const membershipTitle = isFlexibleMembershipsEnabled
            ? `Membership Credit – ${i.source.title} (${intervalText})`
            : `Monthly ${i.source.title} Cash`;

          const title = i.source.membershipId
            ? membershipTitle
            : i.source.title;

          return (
            <RepeatCashEntry
              key={i.id}
              title={title}
              date={i.created}
              amount={i.amount}
              transactionType={i.transactionType}
              onClick={onClickHandler}
              repeatCashType={i.repeatCashType}
            />
          );
        })}
      </div>
    </div>
  );
};
